const filtersMapping = {
    biddingReport: {
        providersParams: {
            includeOnlyBidders: true
        },
        appParams: {
            platform: ['ios', 'android']
        }
    },
    performanceReport: {
        providersParams: {
            definedOnly: true,
            includeSupersonic: true,
            includeTags: true,
            includeBidders: true
        },
        appParams: {
            platform: ['web', 'ios', 'android']
        }
    }
};

export default filtersMapping;
